import React, { useEffect, useState } from "react";
import "./App.css";
import { useLocation, useNavigate, useRoutes } from "react-router-dom";
import { routes } from "./router/routes";
import Header from "./components/header/Header";
import Aside from "./components/aside/Aside";
import PopUpWindow from "./components/pop-up/PopUpWindow";
import { selectIsOpenModal } from "./redux/slices/popUpSlice";
import { useDispatch, useSelector } from "react-redux";
import { selectIsLoggedIn, setLoginData } from "./redux/slices/userSlice";
import OrderModal from "./components/modal/OrderModal";
import { getNotificationsAndNewOrder } from "./axios/api/OrderApi";
import { setBellNotificationData } from "./redux/slices/bellNotificationSlice";
import { refreshToken } from "./axios/api/loginApi";

function App() {
  const element = useRoutes(routes);
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isOpenPopUp = useSelector(selectIsOpenModal);
  const isLoggedIn = useSelector(selectIsLoggedIn);
  const [fontClass, setFontClass] = useState("font-roboto");
  const [isModalHasData, setIsModalHasData] = useState(null);

  const userData = localStorage.getItem("userData");

  const handleCloseModal = () => setIsModalHasData(null);

  useEffect(() => {
    if (!userData) return;

    const getPollNotifications = async () => {
      const id = localStorage.getItem("lastOrderId");
      const responseData = await getNotificationsAndNewOrder(id);

      if (responseData?.data?.bellNotification) {
        dispatch(setBellNotificationData(responseData?.data?.bellNotification));
      }

      if (responseData?.data?.newOrder) {
        setIsModalHasData(responseData?.data?.newOrder);
      } else {
        setIsModalHasData(null); // Reset state if no newOrder
      }
    };

    getPollNotifications();

    const intervalId = setInterval(getPollNotifications, 30000);

    return () => clearInterval(intervalId); // cleanup
  }, [userData]);

  // List of paths where the Header and Aside should not be displayed
  const hideHeaderAndAside = ["/", "/forgot_password", "/reset_password"];
  const shouldHideHeaderAndAside = hideHeaderAndAside.includes(
    location.pathname
  );

  // check auth
  useEffect(() => {
    const storedUserData = JSON.parse(localStorage.getItem("userData"));
    const currentRoute = routes.find(
      (route) => route.path === location.pathname
    );

    if (shouldHideHeaderAndAside && storedUserData) {
      localStorage.removeItem("userData");
      dispatch(setLoginData(false));
    }

    // Check if the current route requires authentication
    if (currentRoute?.meta?.auth && !storedUserData?.token) {
      navigate("/");
      dispatch(setLoginData(false));
      localStorage.removeItem("userData");
    }
  }, [dispatch, location, navigate, shouldHideHeaderAndAside]);

  useEffect(() => {
    const lastRefreshDashboard = localStorage.getItem("lastRefreshDashboard");
    const now = Date.now();

    const oneDay = 24 * 60 * 60 * 1000;

    if (!lastRefreshDashboard || now - lastRefreshDashboard > oneDay) {
      refreshToken();
      localStorage.setItem("lastRefreshDashboard", now.toString());
    }
  }, []);

  useEffect(() => {
    const checkVerification = async () => {
      try {
        const queryParams = new URLSearchParams(location.search);
        const forgotPassword = queryParams.get("forgotPassword");

        if (forgotPassword) {
          // Store the token and navigate to the reset_password page
          localStorage.setItem("token", forgotPassword);
          navigate("/reset_password");
        }
      } catch (error) {
        console.error("Verification error:", error);
      }
    };

    checkVerification();
  }, [location.search, navigate]);

  useEffect(() => {
    try {
      const storedUserData = localStorage.getItem("userData");
      if (storedUserData) {
        const parsedUserData = JSON.parse(storedUserData);
        dispatch(setLoginData(parsedUserData));
      }
    } catch (error) {
      console.error("", error);
    }
  }, [dispatch]);

  useEffect(() => {
    const storedLanguage = localStorage.getItem("language");
    if (storedLanguage === "am") {
      setFontClass("font-mardato");
    } else {
      setFontClass("font-roboto");
    }
  }, []);

  return (
    <div className={`App  ${fontClass}`}>
      {/* Main content area with Header and Aside */}
      <div className="flex">
        {/* Conditionally render Aside */}
        {!shouldHideHeaderAndAside && <Aside />}

        {/* Header should be next to Aside */}
        <div className="flex flex-col flex-1">
          {!shouldHideHeaderAndAside && (
            <div className="mx-6">
              <Header />
            </div>
          )}

          {/* Main content area */}
          {isOpenPopUp && <PopUpWindow />}
          {/* {true && <Toaster message="You cant go login page" />} */}
          {isModalHasData ? (
            <OrderModal onClose={handleCloseModal} rowData={isModalHasData} />
          ) : null}

          <div>{element}</div>
        </div>
      </div>
    </div>
  );
}

export default App;
